module.exports = "<div ng-if=$ctrl.basket.contents.guest_details.length class=c-basket-indicator> <div class=\"c-basket-indicator--dot t-text--primary\" ng-if=\"$ctrl.displayType === 'dot'\"> <span ng-bind=$ctrl.basket.contents.aggregate_total></span> </div> <div class=c-basket-indicator--bar ng-if=\"$ctrl.displayType === 'bar'\" ng-bind=\"$ctrl.basket.contents.item_total + ($ctrl.basket.contents.item_total > 1 ? ' events' : ' event') + ' and ' + $ctrl.basket.contents.guest_total + ' guests'\"> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/basket/views/basket.indicator.html
// module id = 690
// module chunks = 0